module.exports = __webpack_public_path__ + "media/favicon/safari-pinned-tab-b777ce0b50bcdbc98f01589a97b38daf.svg";